import Navbar from "./components/Navbar";
import HeroSection from "./components/HeroSection";
import ShowroomHub from "./components/ShowroomHub";
import TrinitySection from "./components/TrinitySection";
import FulfillmentSection from "./components/FulfillmentSection";
import FAQSection from "./components/FAQSection";
import ContactSection from "./components/ContactSection";
import Footer from "./components/Footer";
import StickyQuoteButton from "./components/StickyQuoteButton";
import GeoAnnouncementBar from "./components/GeoAnnouncementBar";
import PageSEO from "@/components/feature/PageSEO";

const SITE_URL = import.meta.env.VITE_SITE_URL || "https://chirunnexa.com";

const homeJsonLd = [
  {
    "@context": "https://schema.org",
    "@type": "WebPage",
    "name": "OEM Auto Parts Sourcing Guangzhou | Engine Block Foundry China | Chirunnexa",
    "url": `${SITE_URL}/`,
    "description": "Chirunnexa — B2B auto parts sourcing from Guangzhou Export Hub. Precision engine block foundry China: Renault K4M 1.6 16V wholesale, 1:1 OEM quality. Shell Helix Ultra genuine HK channel. FCL/LCL via Guangzhou & Ningbo ports.",
    "inLanguage": "en",
    "isPartOf": {
      "@type": "WebSite",
      "name": "Chirunnexa",
      "url": `${SITE_URL}/`,
    },
    "breadcrumb": {
      "@type": "BreadcrumbList",
      "itemListElement": [
        { "@type": "ListItem", "position": 1, "name": "Home", "item": `${SITE_URL}/` },
      ],
    },
  },
  {
    "@context": "https://schema.org",
    "@type": "ItemList",
    "name": "Chirunnexa Product Categories",
    "description": "B2B auto parts and industrial supply categories available from Chirunnexa Guangzhou Export Hub",
    "itemListElement": [
      {
        "@type": "ListItem",
        "position": 1,
        "name": "Engine Block Foundry & Manufacturing",
        "url": `${SITE_URL}/foundry`,
        "description": "Precision engine block manufacturing: 1:1 OEM quality, integrated foundry and CNC machining, reverse engineering.",
      },
      {
        "@type": "ListItem",
        "position": 2,
        "name": "Shell Helix Ultra Lubricants Wholesale",
        "url": `${SITE_URL}/lubricants`,
        "description": "100% authentic Shell Helix Ultra lubricants via Hong Kong authorized channels. FCL/LCL wholesale.",
      },
      {
        "@type": "ListItem",
        "position": 3,
        "name": "Shell Industrial Oil Series",
        "url": `${SITE_URL}/industrial-oils`,
        "description": "Full Shell industrial range: Tellus, Omala, Corena, Spirax, Morlina, Diala. B2B wholesale export.",
      },
      {
        "@type": "ListItem",
        "position": 4,
        "name": "European OE Parts Catalog",
        "url": `${SITE_URL}/catalog`,
        "description": "15,000+ SKU OE cross-reference database for Mercedes-Benz, BMW, Audi, VW, Porsche, Jaguar, Land Rover.",
      },
    ],
  },
];

export default function HomePage() {
  return (
    <div style={{ background: "#050d1a" }}>
      <PageSEO
        title="OEM Auto Parts Sourcing Guangzhou | Engine Block Foundry China | Chirunnexa"
        description="Chirunnexa — B2B auto parts sourcing from Guangzhou Export Hub. Precision engine block foundry China: Renault K4M 1.6 16V wholesale, 1:1 OEM quality. Shell Helix Ultra genuine HK channel. FCL/LCL via Guangzhou & Ningbo ports. EAC & ISO certified. B2B quote within 24h."
        keywords="OEM auto parts sourcing, engine block foundry China, Guangzhou export hub, Renault K4M wholesale, Shell Helix Ultra wholesale, cast iron engine block supplier, reverse engineering auto parts, B2B auto parts China"
        canonical="/"
        hreflangRu="/ru/"
        jsonLd={homeJsonLd}
      />
      <GeoAnnouncementBar />
      <Navbar />
      <HeroSection />
      <TrinitySection />
      <ShowroomHub />
      <FulfillmentSection />
      <FAQSection />
      <ContactSection />
      <Footer />
      <StickyQuoteButton />
    </div>
  );
}
